/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveForwardIcon64Regular = forwardRef('TimeClockMoveForwardIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M26.452 9.68A23 23 0 0 1 52.2 21H44.5a1.5 1.5 0 0 0 0 3h9.75A2.75 2.75 0 0 0 57 21.25V11a1.5 1.5 0 1 0-3 0v7.144a26 26 0 1 0 .984 26.012 1.5 1.5 0 0 0-2.652-1.403 23 23 0 1 1-25.88-33.074Z" }),
        React.createElement("path", { d: "M32 19.5a1.5 1.5 0 0 0-3 0v10.528a5.5 5.5 0 0 0 3.04 4.92l8.79 4.394a1.5 1.5 0 0 0 1.34-2.684l-8.788-4.394A2.5 2.5 0 0 1 32 30.028V19.5Z" })));
});
